import { render, staticRenderFns } from "./travelData.vue?vue&type=template&id=2c5f33b6&"
import script from "./travelData.vue?vue&type=script&lang=js&"
export * from "./travelData.vue?vue&type=script&lang=js&"
import style0 from "./travelData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports